import './App.css';
import Navbar from './components/navbar/Navbar';
import News from './components/news/News';

function App() {
  return (
    <div>
      <Navbar/>
      <News/>
    </div>
  );
}

export default App;
